import { render, staticRenderFns } from "./singlecourse.vue?vue&type=template&id=fa2e1b3e&scoped=true&"
import script from "./singlecourse.vue?vue&type=script&lang=js&"
export * from "./singlecourse.vue?vue&type=script&lang=js&"
import style0 from "./singlecourse.vue?vue&type=style&index=0&id=fa2e1b3e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa2e1b3e",
  null
  
)

export default component.exports